// -------------------------------------
// Hamburger Active
// -------------------------------------
var $hamburger = jQuery(".hamburger");
$hamburger.on("click", function(e) {
  $(this).toggleClass("is-active");
});